import { Entity } from '../models.interface';

export interface TranslationValue extends Entity {
  lang: string;
  value: string;
}

export class EmptyTranslationValue implements TranslationValue {
  id = null;
  lang = null;
  value = null;
}
